import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { IonicModule } from "@ionic/angular";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { SpaceViewComponent } from "./space-view.component";
import { LoadingStiModule } from "src/app/_component/loading-sti/loading-sti.module";
import { SharedDirectivesModule } from "src/app/_directives/shared-directives.module";
import { UserAssignmentViewDetailsComponentModule } from "../user-assignment-view/user-assignment-view-details/user-assignment-view-details.module";
import { SpaceChartModule } from "src/app/app/_component/_space/space-chart/space-chart.module";
import { PipesModule } from "src/app/_pipes/pipes.module";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    TranslateModule,
    RouterModule,
    LoadingStiModule,
    SharedDirectivesModule,
    UserAssignmentViewDetailsComponentModule,
    SpaceChartModule,
    PipesModule
  ],

  declarations: [SpaceViewComponent],
  exports: [SpaceViewComponent],
})
export class SpaceViewModule {}
